import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";

import { useAppStore } from "@/store";
import { AudioRecordingDetailContent } from "./audio-recording-detail-content";
import { MDSPanelContainer, MDSText, MDSTextVariant } from "@/mds";

export const AudioRecordingAdminPage: FC = observer(() => {
  const { recordingId } = useParams<{ recordingId: string }>();
  const { store } = useAppStore();

  useEffect(() => {
    if (!recordingId) return;
    void store.audioRecordings.getAsync(recordingId);
  }, [recordingId, store.audioRecordings]);

  if (!recordingId) {
    return (
      <PageWrapper>
        <ScrollArea>
          <StatusText variant={MDSTextVariant.TextSm}>Not found.</StatusText>
        </ScrollArea>
      </PageWrapper>
    );
  }

  const recording = store.audioRecordings.get(recordingId);
  const doesNotExist = store.audioRecordings.doesNotExist(recordingId);

  if (!recording) {
    return (
      <PageWrapper>
        <ScrollArea>
          <StatusText variant={MDSTextVariant.TextSm}>
            {doesNotExist ? "Audio recording not found." : "Loading audio recording…"}
          </StatusText>
        </ScrollArea>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <ScrollArea>
        <AudioRecordingDetailContent recording={recording} />
      </ScrollArea>
    </PageWrapper>
  );
});

const PageWrapper = styled(MDSPanelContainer)`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`;

const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const StatusText = styled(MDSText)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;
